<div class="bg-white border m-2 pt-3 px-3 d-flex flex-column shadow-sm">
  <era-apple-device-ui [device]="device$ | async"
                       (applicationLockChange)="applicationLockChanged($event)"
                       (updateDeviceEvent)="updateDevice($event)"
                       (desiredNameChange)="updateDesiredName($event)"
                       [isAtLatestAllowedOsVersion]="isAtLatestAllowedOsVersion()"></era-apple-device-ui>
  <era-device-action-bar [device]="device$ | async"></era-device-action-bar>
</div>

<era-device-os-update-status></era-device-os-update-status>

<era-device-sync-status></era-device-sync-status>
@if (isMdmLostModeEnabled$ | async) {
  <era-device-swapped-current></era-device-swapped-current>
}

<era-device-scheduled-tasks></era-device-scheduled-tasks>

<router-outlet></router-outlet>